(function () {
    'use strict';

    angular.module('app')
        .factory('urlHelper', urlHelper);

    urlHelper.$inject = ["$location"];

    function urlHelper($location) {

        function getPortPresentation() {

            var port = $location.port();
            if (port)
                return ':' + port;

            return '';
        }

        return {
            getApiUrl: function() {
                //var url = "http://local.ripe.co.uk/data/api/";

                var url = $location
                    .protocol() +
                    '://' +
                    $location.host() + getPortPresentation() + '/data/api/'; //uncomment when using local IIS
                return url;
            },
            getMembersApiUrl: function() {
                var url = $location.protocol() + '://' + $location.host() + "/jrwarea/Api/";
                return url;
            },
            getUrl: function() {
                var url = $location.protocol() + '://' + $location.host() + "/"; //uncomment when using local IIS

                return url;
            },
            getSuperbrandApiUrl: function () {
                return $location.protocol() + '://' + $location.host() + getPortPresentation() + '/api/';
            },
            getSuperbrandSiteUrl: function () {
                return $location.protocol() + '://' + $location.host() + getPortPresentation() + '/';
            }
        };
    }
})();